import { PairingContext } from 'context/PairingContext';
import { useContext } from 'react';

export function usePairingContext() {
	return useContext(PairingContext);
}
